// React
import React from 'react';

// Components
import CallInterval from './CallInterval';

// Assets
import { PhoneFilled } from '@ant-design/icons';

// Packages
import { Button, Stack, Typography } from '@mui/material';

// Calls and intercoms still open under the operator that the page lost hold of (a reload
// mid-call, a browser restart). Answering stays disabled until each is resumed or ended.
const UnfinishedSessions = ({ sessions, onResume, onEnd, busy }) => (
    <Stack spacing={1}>
        {sessions.map(session => {
            const { kind, record } = session;
            const startedAt = kind === 'call' ? record.field_start : record.connection_start;

            return (
                <Stack
                    key={`${kind}-${record.id}`}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{
                        px: 2,
                        py: 1.5,
                        borderRadius: '14px',
                        border: '1px solid rgba(250, 173, 20, 0.35)',
                        backgroundColor: '#FFFBF0'
                    }}
                >
                    <Stack
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            width: 40,
                            height: 40,
                            flexShrink: 0,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(250, 173, 20, 0.16)',
                            color: '#D48806'
                        }}
                    >
                        <PhoneFilled style={{ fontSize: 18 }} />
                    </Stack>
                    <Stack sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="body1"
                            color="text.primary"
                            sx={{ fontWeight: 600 }}
                            noWrap
                        >
                            {record.panel_name || 'Kiosk'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {`Unfinished ${kind}`}
                            {startedAt?.toDate && (
                                <>
                                    {' · '}
                                    <CallInterval createdAt={startedAt} />
                                </>
                            )}
                            {' · Resume or end it to answer new calls'}
                        </Typography>
                    </Stack>
                    <Button
                        disableRipple
                        variant="text"
                        disabled={busy}
                        onClick={() => onEnd(session)}
                        sx={{
                            flexShrink: 0,
                            color: 'rgba(230, 58, 58, 1)',
                            fontSize: '0.9375rem',
                            '&.MuiButton-root:hover': { bgcolor: 'transparent' },
                            '&:active::after': { display: 'none' }
                        }}
                    >
                        End
                    </Button>
                    <Button
                        variant="contained"
                        disabled={busy}
                        onClick={() => onResume(session)}
                        sx={{
                            flexShrink: 0,
                            px: 3,
                            borderRadius: '26.5px',
                            fontSize: '0.9375rem',
                            '&:active::after': { borderRadius: '26.5px' }
                        }}
                    >
                        Resume
                    </Button>
                </Stack>
            );
        })}
    </Stack>
);

export default UnfinishedSessions;
